module.exports = __webpack_public_path__ + "img/shop_A_0.2758c0a9.png";